export enum MyChartMedicineTypes {
  PATIENT = 'patient',
  HOSPITAL = 'hospital',
  ALL = 'ALL',
}